import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LEAD_BASED_PAINT } from '@shared/utils/app-static-data';
import { ConfirmationDialogueComponent } from 'app/components/common/confirmation-dialogue/confirmation-dialogue.component';
import { IIndividualContactInformation } from 'app/models/individuals/individual-contact-information';
import { CommonService } from 'app/services/common/common.service';
import { SharedService } from 'app/services/core/shared.service';
import { IndividualService } from 'app/services/individuals/individual.service';
import { ToastrService } from 'ngx-toastr';
import { PUBLIC_FIRM_CONTACT_TYPES } from '../../firms/firm-edit/firm-edit.constants';

@Component({
  selector: 'app-individual-edit-contact-information-dialog',
  templateUrl: './individual-edit-contact-information-dialog.component.html',
  styleUrls: ['./individual-edit-contact-information-dialog.component.scss']
})
export class IndividualEditContactInformationDialogComponent implements OnInit {
  public contactInformationDataForm = null;
  public contactInformationData!: IIndividualContactInformation;
  public uiData = LEAD_BASED_PAINT;
  public color = this.uiData.individual.color;

  constructor(
    public sharedService: SharedService,
    @Inject(MAT_DIALOG_DATA) public data: { contactInformation: IIndividualContactInformation },
    private readonly toastr: ToastrService,
    private readonly individualService: IndividualService,
    private readonly commonService: CommonService,
    private readonly dialogRef: MatDialogRef<IndividualEditContactInformationDialogComponent>,
    public dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.initializeDataFormFields();
    this.loadData();
  }

  loadData(): void {
    this.contactInformationData = this.data.contactInformation;
    this.loadDataForm();
  }

  initializeDataFormFields(): void {
    this.contactInformationDataForm = new UntypedFormGroup({
      contactType: new UntypedFormControl(''),
      label: new UntypedFormControl(''),
      phone: new UntypedFormControl(''),
      ext: new UntypedFormControl(''),
      cell: new UntypedFormControl(''),
      fax: new UntypedFormControl(''),
      email: new UntypedFormControl(''),
      website: new UntypedFormControl(''),
    });
  }

  loadDataForm(): void {
    for (const controlName in this.contactInformationData) {
      if (this.contactInformationDataForm.controls.hasOwnProperty(controlName)) {
        this.contactInformationDataForm.controls[controlName].setValue(this.contactInformationData[controlName]);
      }
    }

    for (const controlName in this.contactInformationData.contactInformation) {
      if (this.contactInformationDataForm.controls.hasOwnProperty(controlName)) {
        this.contactInformationDataForm.controls[controlName].setValue(this.contactInformationData.contactInformation[controlName]);
      }
    }
  }

  updateDataToSave(): void {
    for (const controlName in this.contactInformationData) {
      if (this.contactInformationDataForm.controls.hasOwnProperty(controlName)) {
        this.contactInformationData[controlName] = this.contactInformationDataForm.controls[controlName].value;
      }
    }

    for (const controlName in this.contactInformationData.contactInformation) {
      if (this.contactInformationDataForm.controls.hasOwnProperty(controlName)) {
        this.contactInformationData.contactInformation[controlName] = this.contactInformationDataForm.controls[controlName].value;
      }
    }
  }

  getContactTypes(): string[] {
    return Object.values(PUBLIC_FIRM_CONTACT_TYPES);
  }

  savePrompt(): void {
    const isNew = this.contactInformationData.id === 0;
    const dialogRef = this.dialog.open(ConfirmationDialogueComponent, {
      width: '400px',
      data: {
        message: isNew ? 'Are you sure you want to <strong>Add</strong> this Contact Information?' : 'Are you sure you want to <strong>Update</strong> the Contact Information?',
        title: isNew ? 'Add the Contact Information' : 'Update the Contact Information'
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.saveData();
      }
    });
  }

  saveData(): void {
    this.updateDataToSave();

    this.commonService.saveContactInformation(this.contactInformationData.contactInformation).subscribe({
      next: (savedContactInformation) => {
        this.contactInformationData.contactInformation = savedContactInformation;
        this.individualService.saveIndividualContactInformation(this.contactInformationData).subscribe({
          next: () => {
            this.toastr.success('Contact Information saved successfully!');
            this.dialogRef.close(true);
          },
          error: (error) => this.toastr.error('Error saving Contact Information: ' + (error?.message || error?.error || 'Unknown error')),
        });
      },
      error: (error) => this.toastr.error('Error saving Contact Information: ' + (error?.message || error?.error || 'Unknown error')),
    });
  }
}